import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "../CheckoutPanel/CheckoutPanel.css";

const TotalsSection = ({ totals, currency, packages, items, promocodeData }) => {
  const { t } = useTranslation();
  const discountAmount = useMemo(() => {
    if (!promocodeData || promocodeData.type !== "sell_discount") return 0;
    const percent = promocodeData.amount || 0;
    return (totals.subtotal * percent) / 100;
  }, [totals.subtotal, promocodeData]);

  const finalTotal = totals.total - discountAmount;
  const displayCurrency = packages[0]?.currency || items?.[0]?.currency;

  return (
    <div className="summary-totals">
      {promocodeData && promocodeData.type === "sell_discount" && (
        <div className="summary-row">
          <span>{t("cart.discount")} ({promocodeData.amount}%)</span>
          <span>-{currency(discountAmount, displayCurrency)}</span>
        </div>
      )}

      <div className="summary-row summary-row--total">
        <span>{t("cart.total")}</span>
        <span>{currency(finalTotal, displayCurrency)}</span>
      </div>
    </div>
  );
};

export default TotalsSection;
